import { ChannelkartNetworkGet,ChannelkartNetworkPut } from "../../services/networkService";
import { openPopup } from "../../stateManagement/actions/popupActions";
import {User, DateRange, PjpPlanConfigType } from "./PjpApprovalTypes";
import { PjpDayCardType } from '../../components/pjpApproval/PjpSummaryCardTypes';
import { getMetaDataConfig } from "../../services/uiConfigService";

  
  const getStartAndEndDate = (): DateRange => {
    const now = new Date();
  
    const startDate = new Date(now.getFullYear(), now.getMonth(), 1);
    const endDate = new Date(now.getFullYear(), now.getMonth() + 2, 0, 23, 59, 59);
  
    const getFormattedDate = (date: Date, format: string): string => {
      const pad = (n: number) => (n < 10 ? `0${n}` : `${n}`);
      return format
        .replace("yyyy", date.getFullYear().toString())
        .replace("MM", pad(date.getMonth() + 1))
        .replace("dd", pad(date.getDate()))
        .replace("HH", pad(date.getHours()))
        .replace("mm", pad(date.getMinutes()))
        .replace("ss", pad(date.getSeconds()));
    };
  
    const formattedStartDate = getFormattedDate(startDate, "yyyy-MM-dd HH:mm:ss");
    const formattedEndDate = getFormattedDate(endDate, "yyyy-MM-dd HH:mm:ss");
  
    return {
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    };
  };
  const getCurrenMonthRange = (): DateRange => {
    const now = new Date();
  
    const startDate = new Date(now.getFullYear(), now.getMonth(), 1);
    const endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59);
  
    const getFormattedDate = (date: Date, format: string): string => {
      const pad = (n: number) => (n < 10 ? `0${n}` : `${n}`);
      return format
        .replace("yyyy", date.getFullYear().toString())
        .replace("MM", pad(date.getMonth() + 1))
        .replace("dd", pad(date.getDate()))
        .replace("HH", pad(date.getHours()))
        .replace("mm", pad(date.getMinutes()))
        .replace("ss", pad(date.getSeconds()));
    };
  
    const formattedStartDate = getFormattedDate(startDate, "yyyy-MM-dd HH:mm:ss");
    const formattedEndDate = getFormattedDate(endDate, "yyyy-MM-dd HH:mm:ss");
  
    return {
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    };
  };
  const getNextMonthRange = (): DateRange => {
    const now = new Date();
  
    const startDate = new Date(now.getFullYear(), now.getMonth() + 1, 1, 0, 0, 0);
    const endDate = new Date(now.getFullYear(), now.getMonth() + 2, 0, 23, 59, 59);
  
    const getFormattedDate = (date: Date, format: string): string => {
      const pad = (n: number) => (n < 10 ? `0${n}` : `${n}`);
      return format
        .replace("yyyy", date.getFullYear().toString())
        .replace("MM", pad(date.getMonth() + 1))
        .replace("dd", pad(date.getDate()))
        .replace("HH", pad(date.getHours()))
        .replace("mm", pad(date.getMinutes()))
        .replace("ss", pad(date.getSeconds()));
    };
  
    const formattedStartDate = getFormattedDate(startDate, "yyyy-MM-dd HH:mm:ss");
    const formattedEndDate = getFormattedDate(endDate, "yyyy-MM-dd HH:mm:ss");
  
    return {
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    };
  };


export const getUser = async (PjpPlanOption : any): Promise<User[]> => {
    try {
        const dateRange = getStartAndEndDate();
        const { startDate, endDate } = dateRange;

        const status = PjpPlanOption?.appApprovalPlan === "1" ? "Pending" : "DSEApproved,Pending&operator=in";

        const authContext = localStorage.getItem("authContext");
        const loginId = authContext ? JSON.parse(authContext).user.loginId : null;
        const approvedBy = PjpPlanOption?.pjpApproval?.pjpApprovalCheck === false ? "" : `&approvedBy=${loginId}`;

        const response = await ChannelkartNetworkGet(`/v1/deliveryPJP/PJPPlan/loginId?startDate=${startDate}&endDate=${endDate}${approvedBy}&status=${status}`);
     
        if (response.status === 200) {
          const users = response.data.features;
        
          return users;
        }
        else {
            return [];
            }
  
    } catch (error) {
      console.error("Error fetching user data:", error);
      return [];
    }
  };


export const getPjpData = async (selectedUser : User | null, PjpPlanOption : any ) => {
    if(selectedUser == null) return [];

    try {
        const dateRange = getStartAndEndDate();
        const currMonthRange = getCurrenMonthRange();
        const nextMonthRange = getNextMonthRange();
        const { startDate, endDate } = dateRange;
        const { startDate: currMonthStartDate, endDate: currMonthEndDate } = currMonthRange;
        const { startDate: nextMonthStartDate, endDate: nextMonthEndDate } = nextMonthRange;
  
        const status = PjpPlanOption?.appApprovalPlan === "1" ? "Pending" : "DSEApproved,Pending&operator=in";
        const authContext = localStorage.getItem("authContext");
        const loginId = authContext ? JSON.parse(authContext).user.loginId : null;
        const loginid = selectedUser.loginid;
        const approvedBy = PjpPlanOption?.pjpApproval?.pjpApprovalCheck == false ? "" : `&approvedBy=${loginId}`;

        if(PjpPlanOption?.pjpApproval?.pjpApprovalCheck == false){
          const response1 = await ChannelkartNetworkGet(`/v1/deliveryPJP/PJPPlan?startDate=${currMonthStartDate}&endDate=${currMonthEndDate}&loginId=${loginid}${approvedBy}&status=${status}&rate=true&sort=pjp_date:desc`);
          const response2 = await ChannelkartNetworkGet(`/v1/deliveryPJP/PJPPlan?startDate=${nextMonthStartDate}&endDate=${nextMonthEndDate}&loginId=${loginid}${approvedBy}&status=${status}&rate=true&sort=pjp_date:desc`);
          
          let currData = [];
          let nextData = [];
          if (response1.status === 200) {
            currData = response1.data.features;
          }
          if (response2.status === 200) {
            nextData = response2.data.features;
          }
          if (currData.length !== 0 || nextData.length !== 0) {
            return {
              "curr": currData,
              "next": nextData
            };
          }

        }else{
          const response = await ChannelkartNetworkGet(`/v1/deliveryPJP/PJPPlan?startDate=${startDate}&endDate=${endDate}&loginId=${loginid}${approvedBy}&status=${status}&rate=true&sort=pjp_date:desc`);
          
          if (response.status === 200) {
            const PjpData = response.data.features;

            return PjpData;
          }
          else {
            return [];
          }
        }
  
    } catch (error) {
      console.error("Error fetching Pjp data:", error);
      return [];
    }
  };


export const PjpPlanConfig = async () : Promise<PjpPlanConfigType | undefined> => {
    const localStorageValue = localStorage.getItem("authContext");
    let role: string = "";
    if (localStorageValue !== null) {
      role = JSON.parse(localStorageValue).user?.designation?.[0];
    }
 
    try {
      const clientConfig = await getMetaDataConfig(
        "clientconfig",
        `${role}_app_options_configuration`
      );

      const portalConfig = await getMetaDataConfig(
        "clientconfig",
        "portal_configuration"
      );

     
      const PjpPlanOptionConfig = clientConfig?.domainValues?.find(
        (config: any) => config.name === "pjpPlanOptions"
      );
      const appApprovalPlan = clientConfig?.domainValues?.find(
        (config: any) => config.name === "appApprovalPlan"
      );

      const pjpApproval = portalConfig?.domainValues?.find(
        (config: any) => config.name === "pjpApproval"
      );

      return {
        appApprovalPlan: appApprovalPlan?.value,
        PjpPlanOptionConfig : PjpPlanOptionConfig?.value,
        pjpApproval: pjpApproval?.value,
      }

    } catch (e) {
      console.error("Error fetching PjpPlanOptionConfig", e);
      return undefined;
    }
}

export const transformPjpSummary = (
  PjpData: any,
  PjpPlanConfig: any,
  { showRoutesErrorPopup = true } = {} // Default value for the optional parameter
) => {
  if (!PjpData || PjpData.length === 0) {
    return null; 
  }

  const firstFeature = PjpData[0];

  const status = (PjpPlanConfig?.appApprovalPlan === "1") || (firstFeature.designation && firstFeature.designation !== 'psr') ? "Pending" : "DSEApproved";

  // Show popup only if showRoutesErrorPopup is true
  if ((firstFeature.routeCodeValid.toUpperCase() === "N" || firstFeature.routeCodeNHValid.toUpperCase() === "N") && showRoutesErrorPopup) {
    openPopup("Alert", "There are some routes selected by the user which are not available in approved Rate master.", () => {});
  }

  let PjpPlans = [
    { label: "MARKET WORK", bgColor: "#eff8f7", textColor: "#31c2b1" },
    { label: "MEETING", bgColor: "#eff8f7", textColor: "#2e5bff" },
    { label: "WEEKLY OFF", bgColor: "#eff8f7", textColor: "#face3a" },
    { label: "LEAVE", bgColor: "#eff8f7", textColor: "#face3a" }, 
    { label: "IN TRANSIT", bgColor: "#f4f4fb", textColor: "#9994e0" },
    { label: "HOLIDAY", bgColor: "#87CEEB", textColor: "#87CEEB" },
    { label: "OFFICE", bgColor: "#87CEEB", textColor: "#f7885c" },
    { label: "WORK FROM HOME", bgColor: "#fef9e6", textColor: "#4c4c4c" },
    { label: "OTHERS", bgColor: "#87CEEB", textColor: "#31c2b1" },
  ];  

  if(PjpPlanConfig?.pjpApproval?.pjpPlanOptions){
    PjpPlans = PjpPlanConfig?.pjpApproval?.pjpPlanOptions;
  }
  
  // Calculate PJP plan counts
  const pjpPlanCounts = PjpData?.reduce((acc: Record<string, number>, feature: any) => {
    const extendedAttributes = JSON.parse(feature.extended_attributes || "{}");
    const pjpPlan = extendedAttributes?.PJPPlan.toUpperCase();
  
    if (pjpPlan) {
      acc[pjpPlan] = (acc[pjpPlan] || 0) + 1;
    }
    return acc;
  }, {});
  
  
  pjpPlanCounts["WEEKOFF / LEAVE"] = (pjpPlanCounts["WEEKLY OFF"] || 0) + (pjpPlanCounts["LEAVE"] || 0);
  
  
  
  const weeklyOffConfig = PjpPlanConfig?.PjpPlanOptionConfig?.find(
    (plan: Record<string, any>) => plan.label.toUpperCase() === "WEEKLY OFF"
  );
  
  const updatedPjpPlans = PjpPlans?.map((plan) => {
    const { label, bgColor, textColor } = plan;
   
    let planConfig = PjpPlanConfig?.PjpPlanOptionConfig?.find(
      (plan: Record<string, any>) => plan.label.toUpperCase() ===label.toUpperCase()
    );

    if (PjpPlanConfig?.pjpApproval?.pjpPlanOptions) {
      planConfig = PjpPlanConfig?.pjpApproval?.pjpPlanOptions?.find(
        (plan: Record<string, any>) => plan.label.toUpperCase() === label.toUpperCase()
      );
    }
  
   
    const defaultConfig = {
      id: label.toLowerCase().replace(/\s+/g, "_"),
      label: label,
      colour: "#000",  
      bgColor: bgColor,
      textColor: textColor, 
      count: 0,
    };

    if (!PjpPlanConfig?.pjpApproval?.pjpPlanOptions){
      if (label.toUpperCase() === "LEAVE") {
        return null;
      }

      if (label.toUpperCase() === "WEEKLY OFF") {
        return {
          id: "weekoff_leave",
          label: "WEEKOFF / LEAVE",
          colour: weeklyOffConfig?.colour || "#000",
          bgColor: weeklyOffConfig?.bgColor || "#eff8f7",
          textColor: weeklyOffConfig?.textColor || "#face3a",
          count: pjpPlanCounts["WEEKOFF / LEAVE"] || 0,
        }
      }
    }
  
    
    return {
      ...defaultConfig,
      count: pjpPlanCounts[label.toUpperCase()] || 0,
      ...(planConfig || {}),
    };
  }).filter(Boolean); 
  

  


  const monthNumber = parseInt(firstFeature.pjp_date.split("-")[1], 10);
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  
  const monthName = monthNames[monthNumber - 1];

  return {
    status,
    pjpPlanCounts: pjpPlanCounts, 
    month: monthName,
    PjpPlanOptions: updatedPjpPlans
  };
}

export const transformDayCard = (
  PjpData: any,
  PjpPlanConfig: any
): PjpDayCardType[] => {
  if (!Array.isArray(PjpData)) return [];

  // ✅ Sort by date (ascending)
  const sortedData = [...PjpData].sort((a, b) => {
    const dateA = new Date(
      JSON.parse(a.extended_attributes || "{}").date ||
      JSON.parse(a.extended_attributes || "{}").pjpDate ||
      ""
    ).getTime();
    const dateB = new Date(
      JSON.parse(b.extended_attributes || "{}").date ||
      JSON.parse(b.extended_attributes || "{}").pjpDate ||
      ""
    ).getTime();
    return dateA - dateB;
  });

  return sortedData.map((pjp: any) => {
    const extendedAttributes = JSON.parse(pjp.extended_attributes || "{}");

    const date = extendedAttributes.date || extendedAttributes.pjpDate || "";
    const PJPPlan = extendedAttributes.PJPPlan || "";
    const visitPlan = extendedAttributes.visitPlan || "";
    const beat = extendedAttributes.beatName || "";

    const startTown = extendedAttributes.fromTownName || "";
    const workTown = extendedAttributes.toTownName || "";
    const nhTown = extendedAttributes.NHTownName || "";
    const meetingTown = extendedAttributes.meetingTownName || "";
    const nhExist = pjp.NHExist || "";
    const routeCodeValid = pjp.routeCodeValid || "";
    const routeCodeNHValid = pjp.routeCodeNHValid || "";
    const statusRemarks = extendedAttributes.statusRemarks || "";
    const routeCodeNH = extendedAttributes.routeCodeNH || "";
    const routeCode = extendedAttributes.routeCode || "";
    const status = extendedAttributes.status || "";
    const userName = extendedAttributes.name || "";
    const dbName = extendedAttributes.dbName || "";

    let matchingConfig =
      PjpPlanConfig?.PjpPlanOptionConfig?.find(
        (config: any) => config.label.toUpperCase() === PJPPlan.toUpperCase()
      ) || null;

    if (PjpPlanConfig?.pjpApproval?.pjpPlanOptions) {
      matchingConfig =
        PjpPlanConfig?.pjpApproval?.pjpPlanOptions?.find(
          (plan: Record<string, any>) =>
            plan.label.toUpperCase() === PJPPlan.toUpperCase()
        ) || matchingConfig;
    }

    const bgColor = matchingConfig?.bgColor || "#ffffff";
    const textColor = matchingConfig?.textColor || "#000000";
    const showDetail = PjpPlanConfig?.pjpApproval?.showDetail ?? true;
    const showVisitPlan = PjpPlanConfig?.pjpApproval?.showVisitPlan ?? true;

    return {
      date,
      PJPPlan,
      visitPlan,
      beat,
      bgColor,
      textColor,
      startTown,
      workTown,
      nhTown,
      meetingTown,
      nhExist,
      routeCodeValid,
      routeCodeNHValid,
      statusRemarks,
      routeCodeNH,
      routeCode,
      status,
      userName,
      dbName,
      showDetail,
      showVisitPlan,
    };
  });
};

export async function submitPjpApprovalData(
  pjpData: any[],
  managerRemarks: string,
  PjpPlanConfig: any,
  action: 'approve' | 'reject',
  psrloginid?: string
): Promise<string> {
  const localStorageValue = localStorage.getItem("authContext");
  let role: string = "";
  let immediateParent: string = "";

  if (localStorageValue !== null) {
    const authContext = JSON.parse(localStorageValue);
    role = authContext.user?.designation?.[0] || "";
    immediateParent = authContext.user?.immediateParent || "";
  }

  let status = "approved";
  if (action === 'approve') {
    if (PjpPlanConfig.appApprovalPlan === "1") {
      status = "DSEApproved";
    }
  
    if (role === "bsm" && status === "DSEApproved") {
      status = "approved";
    }

  } else {
    status= "rejected"
  }
 

  const pjpApprovalBody = pjpData.map((dayData) => {
    const parsedAttributes = JSON.parse(dayData.extended_attributes || "{}");

    return {
      status: status,
      statusRemarks: managerRemarks,
      pjpDate: dayData.pjp_date ? dayData.pjp_date.split("T")[0] : "", 
      referenceNumber: psrloginid
        ? `${psrloginid}:${dayData.pjp_date.split("T")[0]}`
        : `${dayData.userName}:${dayData.pjp_date.split("T")[0]}`,
      loginId: psrloginid || dayData.userName || "",
      approvedBy: (PjpPlanConfig?.pjpApproval?.pjpApprovalCheck == false) ? "admin" : (immediateParent || ""),
      beat: dayData.beat || "NA",
      pjpPlan: parsedAttributes.PJPPlan || "",
    };
  });

  const finalObj = {
    features: pjpApprovalBody,
  };

  

  try {
    const res = await ChannelkartNetworkPut(
      "/v1/deliveryPJP/batch",
      finalObj
    );

    if (res.status === 200 || res.status === 201) {
      return "";
    } else {
      return "failed";
    }
  } catch (error) {
    console.error("Error during PJP approval submission:", error);
    return "failed";
  }
}








